import React, { useEffect } from 'react';
import { VoucherFormSection } from '../../Section';
import { useVoucherFormContext } from '../../Context';
import AllowedCustomerRuleEditor from './AllowedCustomerRuleEditor';

const VoucherFormCustomer: React.FC = () => {
  const {
    formState: {
      payload: { count, rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const isSingleVoucher = count === 1;

  // Customer restriction only applies to single vouchers; clear any stale rule otherwise.
  useEffect(() => {
    if (!isSingleVoucher && rules.some(r => r.type === 'allowed_customer')) {
      handleRuleChange({ type: 'allowed_customer', identifiers: [] }, true);
    }
  }, [isSingleVoucher, rules, handleRuleChange]);

  if (!isSingleVoucher) {
    return null;
  }

  return (
    <VoucherFormSection
      title='Customer'
      subtitle='Restrict the voucher to a specific customer.'
      inputs={<AllowedCustomerRuleEditor />}
    />
  );
};

export default VoucherFormCustomer;
